import React from "react";
import { Button, Box, Text } from "@mantine/core";
import { DEFAULT_THEME } from "../../shared/util/consts";
import { ThemeType } from "../../shared/util/types";

export type MultipleChoiceButtonInterface = {
  text: string;
  value: string;
  isImage?: boolean;
  style?: React.CSSProperties;
};

type MultipleChoiceButtonsProps = {
  instructions?: string;
  subInstructions?: string;
  options: MultipleChoiceButtonInterface[];
  theme?: ThemeType;
  onSelect: (option: string) => void;
};

const MultipleChoiceButtons: React.FC<MultipleChoiceButtonsProps> = ({
  instructions,
  subInstructions,
  options,
  theme = DEFAULT_THEME,
  onSelect,
}) => {
  const defaultStyle: React.CSSProperties = {
    backgroundColor: theme.BackgroundColor,
    color: theme.TextColor,
    //font: theme.Font,
    fontSize: "16px",
    border: "1px solid #fff",
    borderRadius: "5px",
    width: "50%",
    minWidth: "300px",
    marginTop: "10px",
    padding: "10px",
    minHeight: "50px",
    height: "auto",
  };
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      {instructions && (
        <Text
          style={{
            color: theme.TextColor,
            fontSize: "24px",
            justifyContent: "center",
            display: "flex",
            textAlign: "center",
          }}
        >
          {instructions}
        </Text>
      )}
      {subInstructions && (
        <Text
          style={{
            color: theme.ReminderColor,
            fontSize: "18px",
            marginTop: "10px",
            justifyContent: "center",
            display: "flex",
            textAlign: "center",
          }}
        >
          {subInstructions}
        </Text>
      )}
      {options.map((option, index) => (
        <Button
          key={index}
          onClick={() => onSelect(option.value)}
          style={{
            ...defaultStyle,
            ...option.style,
          }}
        >
          {option.isImage ? (
            <img
              src={option.text}
              alt="Option"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            option.text
          )}
        </Button>
      ))}
    </Box>
  );
};

export default MultipleChoiceButtons;
